import GrillesZonesKilometriquesController from './grilles.zones.kilometriques.controller';

export default {
    template: require('./grilles.zones.kilometriques.tpl.html'),
    controller: GrillesZonesKilometriquesController
};
